import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form__container" }
const _hoisted_2 = { class: "posInfo" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "operation-theme__container" }
const _hoisted_7 = { class: "fsb-typo-heading-5" }
const _hoisted_8 = { class: "operation-theme" }
const _hoisted_9 = { class: "operation-theme__img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "operation-theme__text" }
const _hoisted_12 = {
  key: 2,
  class: "agents__container"
}
const _hoisted_13 = { class: "fsb-typo-heading-5" }
const _hoisted_14 = { class: "third-bloc" }

import AdsList from '../Campaigns/AdsList.vue';
    import BudgetsRecap from '../Campaigns/BudgetsRecap.vue';
    import BudgetSlider from '../Campaigns/BudgetSlider.vue';
    import DiffusionZone from '../Campaigns/DiffusionZone.vue';
    import { storeToRefs } from 'pinia';
    import { onMounted, ref, watch } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import { useAccessOperationsStore } from '@/store/accessOperations';
    import { useAccessDataStore } from '@/store/accessData';
    import { CheckboxAllOption } from '@/interfaces/CheckboxAllOptions';
    import BaseCheckboxAll from '../shared/BaseCheckboxAll.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'LeftContainer',
  setup(__props) {

    const route = useRoute();
    const router = useRouter();

    const accessOperationsStore = useAccessOperationsStore();
    const accessDataStore = useAccessDataStore();

    const { accessOperations } = storeToRefs(accessOperationsStore);
    const { minBudget, budget } = storeToRefs(accessDataStore);

    const agentsOptions = ref<CheckboxAllOption<{ amount: number }>[]>([]);

    watch(
        () => accessOperations.value.details?.agents_list,
        (agentsList) => {
            if (!agentsList) return;
            agentsOptions.value = Object.keys(agentsList).map((code) => ({
                text: agentsList[code].name,
                subLabel: formatEuro(agentsList[code].amount),
                amount: agentsList[code].amount,
                code: code,
                value: agentsList[code].amount.toString(),
                checked: false,
                disabled: agentsList[code].status !== 'active',
            }));
        }
    );

    watch(agentsOptions, (options) => {
        const checkedAgents = options?.filter((option) => option.checked && !option.disabled);
        accessDataStore.setSelectedAgents(checkedAgents);
    });

    const formatEuro = (amount: number) => {
        return new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
        }).format(amount / 100);
    };

    onMounted(async () => {
        const token = route.params.token as string;
        try {
            await accessOperationsStore.getAccessOperations(token);
            if (!Object.keys(accessOperations.value.details?.agents_list ?? {}).length) budget.value = minBudget.value;
        } catch {
            router.push({ name: 'error' });
        }
    });

return (_ctx: any,_cache: any) => {
  const _component_ad_icon = _resolveComponent("ad-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ad_icon, {
        icon: 'pin',
        variant: "white"
      }),
      (_unref(accessOperations).details?.pos_name)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(accessOperations).details?.pos_name), 1))
        : _createCommentVNode("", true)
    ]),
    (_unref(accessOperations).details?.products_show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(AdsList)
        ]))
      : _createCommentVNode("", true),
    (_unref(accessOperations).details?.diffusion_zone_show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(DiffusionZone)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('operationTheme')) + " :", 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            src: _unref(accessOperations).details?.crea.image_url,
            alt: "banner preview"
          }, null, 8, _hoisted_10)
        ]),
        _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(accessOperations).details?.crea.name), 1)
      ])
    ]),
    (_unref(accessOperations).details?.agents_list)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('selectAgents')), 1),
          _createVNode(BaseCheckboxAll, {
            name: "agents",
            options: agentsOptions.value,
            "onUpdate:options": _cache[0] || (_cache[0] = ($event: any) => ((agentsOptions).value = $event))
          }, null, 8, ["options"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_14, [
        (_unref(accessOperations).details?.slider_show)
          ? (_openBlock(), _createBlock(BudgetSlider, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(BudgetsRecap)
      ])
    ])
  ]))
}
}

})